import { Moment } from "moment";
import { AppThunk, AppDispatch } from "../../types";
import fetchReport from "../../../shared/fetchReport";

type FetchBilledAdsMtdProps = {
  startDate: Moment;
  endDate: Moment;
  report: string;
};
export type FetchBilledAdsMtd = (filters: FetchBilledAdsMtdProps) => void;

const fetchBilledAdsMtd = ({
  startDate,
  endDate,
  report
}: FetchBilledAdsMtdProps): AppThunk => async (dispatch: AppDispatch) => {
  const params = {
    start_date: startDate.format("YYYY-MM-DD"),
    end_date: endDate.format("YYYY-MM-DD"),
  };
  await fetchReport(report, dispatch, params);
};

export default fetchBilledAdsMtd;
